import React from 'react';
import { Input } from 'web-ui-components/lib/atoms/forms';
import { Field as FormField, FieldBody, FieldHeader } from 'web-ui-components/lib/molecules/forms';
import { BlockFieldColumn } from 'web-ui-components/lib/global/layout';
import { Field } from 'react-final-form';
import PropTypes from '../../../types';
import { Content } from '../../../infrastructure/content';
import { isExpiredDate } from '../../../utils/validation';
import { isEmpty } from '../../../utils';
import { MONTH_FIELD, YEAR_FIELD } from '../../../utils/constants';

const YEAR_FIELD_LENGTH = 4;
const validateExpiryDate = allValues => {
  const DATE_TEN = 10;
  const values = allValues;
  if (allValues) {
    let currDate = new Date();
    currDate = currDate.getDate();
    values.dateField = `${currDate < DATE_TEN ? `0${currDate}` : currDate}`;
  }
  if (isExpiredDate(values)) {
    return undefined;
  }
  return 'Required';
};

class ExpiryDate extends React.Component {
  constructor(props) {
    super(props);
    this.autoTab = this.autoTab.bind(this);
    this.state = { touched: false };
    this.onInputBlur = this.onInputBlur.bind(this);
  }

  autoTab(e, value, dateField, len, field2) {
    if (
      isEmpty(document.getElementById(dateField)) &&
      isEmpty(document.getElementById(field2)) &&
      document.getElementById(dateField).value.length === len
    ) {
      document.getElementById(field2).focus();
    }
    this.props.input.onChange({ ...value, [dateField]: e.target.value });
  }

  onInputBlur(value, fieldLength) {
    if (
      !value ||
      isNaN(value) ||
      value.length < fieldLength ||
      validateExpiryDate(this.props.input.value)
    ) {
      this.setState({ touched: true });
    }
  }

  render() {
    const {
      input: { value },
      meta: { touched, error },
      name
    } = this.props;
    return (
      <Content>
        {({
          oldExpiryDateLabel,
          oldExpiryDateValidationMessage,
          personDetailsMonthValue,
          personDetailsYearValue
        }) => (
          <FormField>
            <FieldHeader
              name={name}
              hasError={(this.state.touched || touched) && !!error}
              title={oldExpiryDateLabel}
              validationMessage={oldExpiryDateValidationMessage}
            />
            <FieldBody hasError={(this.state.touched || touched) && !!error}>
              <BlockFieldColumn className="o-block-field__col--stack" column={1}>
                <label htmlFor="monthName" className="c-a-label">
                  <span className="c-a-label__title">{personDetailsMonthValue}</span>
                </label>
                <Input
                  type="tel"
                  id={MONTH_FIELD}
                  maxLength={2}
                  value={value.monthField}
                  onBlur={e => {
                    this.onInputBlur(e.target.value, 2);
                  }}
                  onChange={e => this.autoTab(e, value, MONTH_FIELD, 2, YEAR_FIELD)}
                />
              </BlockFieldColumn>
              <BlockFieldColumn className="o-block-field__col--stack" column={2}>
                <label htmlFor="yearName" className="c-a-label">
                  <span className="c-a-label__title">{personDetailsYearValue}</span>
                </label>
                <Input
                  type="tel"
                  id={YEAR_FIELD}
                  maxLength={4}
                  value={value.yearField}
                  onBlur={e => {
                    this.onInputBlur(e.target.value, YEAR_FIELD_LENGTH);
                  }}
                  onChange={e => this.autoTab(e, value, YEAR_FIELD)}
                />
              </BlockFieldColumn>
            </FieldBody>
          </FormField>
        )}
      </Content>
    );
  }
}

ExpiryDate.propTypes = {
  input: PropTypes.shape({
    onChange: PropTypes.func,
    value: PropTypes.object
  }),
  meta: PropTypes.shape({
    touched: PropTypes.bool,
    error: PropTypes.string
  })
};

const DateField = () => (
  <Field
    name="expiryDate"
    value={{ monthField: '', yearField: '' }}
    component={ExpiryDate}
    validate={validateExpiryDate}
  />
);

export default DateField;
